export const MultiGrid = {
  Office: 'office'
}
